<template>
  <div class="page page-section">
    <div class="list-options">
      <a-form layout="inline" class="options-form">
        <a-row :gutter="24">
          <a-col span="8">
            <a-form-item label="项目类型" :colon="false">
              <a-select placeholder="请选择" v-model="filterForm.projectType" size="default" style="width: 200px" allow-clear>
                <a-select-option :value="11">公募合作—公募合作</a-select-option>
                <a-select-option :value="12">公募合作—专项基金</a-select-option>
                <a-select-option :value="210">螺蛳壳改造</a-select-option>
                <a-select-option :value="21">螺蛳壳改造子项目</a-select-option>
                <a-select-option :value="220">精灵书屋</a-select-option>
                <a-select-option :value="22">精灵书屋子项目</a-select-option>
                <a-select-option :value="230">公益人才</a-select-option>
                <a-select-option :value="23">公益人才子项目</a-select-option>
                <a-select-option :value="240">爱心100</a-select-option>
                <a-select-option :value="24">爱心100子项目</a-select-option>
                <a-select-option :value="25">其他项目</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="8">
            <a-form-item label="费用分类" :colon="false"><a-input v-model="filterForm.cateName" placeholder="输入名称" @pressEnter="load()" size="default" style="width: 200px" /></a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="flex items-center v-my-sm">
      <span></span>
      <div class="v-ml-auto">
        <a-button type="primary" icon="search" size="small" :loading="loading" @click="load()">查询</a-button>
        <a-button icon="plus" type="indigo" class="v-ml-md" size="small" @click="opanModal">添加分类</a-button>
      </div>
    </div>
    <div class="list-table-container">
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" :page-size-options="['10', '20', '30', '50', '100']" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
      <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="cateId">
        <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
          <template slot-scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column title="项目类型" data-index="projectType" align="left" :width="180">
          <template slot-scope="text">
            <span v-if="text == 11">公募合作—公募合作</span>
            <span v-else-if="text == 12">公募合作—专项基金</span>
            <span v-else-if="text == 210">螺蛳壳改造</span>
            <span v-else-if="text == 21">螺蛳壳改造子项目</span>
            <span v-else-if="text == 220">精灵书屋</span>
            <span v-else-if="text == 22">精灵书屋子项目</span>
            <span v-else-if="text == 230">公益人才</span>
            <span v-else-if="text == 23">公益人才子项目</span>
            <span v-else-if="text == 240">爱心100</span>
            <span v-else-if="text == 24">爱心100子项目</span>
            <span v-else-if="text == 25">其他项目</span>
          </template>
        </a-table-column>
        <a-table-column title="费用分类一级科目" data-index="cateRoot" :ellipsis="true" align="left">
          <template slot-scope="text">
            <span v-if="text == 1">项目费</span>
            <span v-else-if="text == 2">申请人管理费</span>
            <span v-else-if="text == 3">美丽心灵管理费</span>
          </template>
        </a-table-column>
        <a-table-column title="费用分类二级科目" data-index="cateName" align="left" :ellipsis="true" />
        <a-table-column title="创建时间" :width="140" data-index="createTime" align="left">
          <template slot-scope="text, record">
            <template>{{ record.createTime ? record.createTime.substring(0, 16) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="action" :width="100" align="center">
          <template slot-scope="text, record">
            <a-space class="table-actions" :size="6">
              <span class="hover-line text-red" title="删除" @click="del(record.cateId)" v-if="!record.state || hasPermission('project:form:review')">删除</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="list-toolbar flex items-center">
        <div class="list-toolbar-extra">
          共
          <span class="text-primary font-special">{{ pagination.total }}</span>
          条记录
        </div>
        <div class="list-pagination v-ml-auto">
          <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" :page-size-options="['10', '20', '30', '50', '100']" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
        </div>
      </div>
    </div>
    <a-modal title="新增费用分类" :visible.sync="showModal" :confirm-loading="submiting" @ok="submit" @cancel="showModal = false" width="500px">
      <a-form-model ref="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
        <a-form-model-item :colon="false" label="项目类型">
          <a-select placeholder="请选择" v-model="saveForm.projectType" size="default" style="width: 100%" ref="projectType">
            <a-select-option :value="11">公募合作—公募合作</a-select-option>
            <a-select-option :value="12">公募合作—专项基金</a-select-option>
            <a-select-option :value="210">螺蛳壳改造</a-select-option>
            <a-select-option :value="21">螺蛳壳改造子项目</a-select-option>
            <a-select-option :value="220">精灵书屋</a-select-option>
            <a-select-option :value="22">精灵书屋子项目</a-select-option>
            <a-select-option :value="230">公益人才</a-select-option>
            <a-select-option :value="23">公益人才子项目</a-select-option>
            <a-select-option :value="240">爱心100</a-select-option>
            <a-select-option :value="24">爱心100子项目</a-select-option>
            <a-select-option :value="25">其他项目</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="费用分类一级科目">
          <a-select placeholder="请选择" v-model="saveForm.cateRoot" size="default" style="width: 100%" ref="cateRoot">
            <a-select-option :value="1">项目费</a-select-option>
            <a-select-option :value="2">申请人管理费</a-select-option>
            <a-select-option :value="3">美丽心灵管理费</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false" label="费用分类二级科目">
          <a-input v-model="saveForm.cateName" placeholder="分类名称" ref="cateName" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { listRecords, delRecord, saveRecord } from '@/api/system/fincate'
export default {
  data() {
    return {
      filterForm: {
        cateName: '',
        projectType: undefined,
      },
      loading: true,
      list: [],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0,
      },
      saveForm: {
        cateRoot: undefined,
        cateName: '',
        projectType: undefined,
      },
      showModal: false,
      submiting: false,
    }
  },
  methods: {
    del(id) {
      this.$confirm({
        title: '确认删除此分类？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delRecord(id)
              .then(({ data }) => {
                if (data.success) {
                  this.$message.success('删除成功')
                  let { page, pageSize } = this.pagination
                  this.load(page, pageSize)
                  resolve()
                } else {
                  this.$message.warning(data.msg)
                  resolve()
                }
              })
              .catch(() => {
                reject()
              })
          })
        },
      })
    },
    load(page = 1, pageSize = 50, sorter) {
      this.loading = true
      let params = {
        page,
        pageSize,
        sorter,
        ...this.filterForm,
      }
      listRecords(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          this.list = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.loading = false
      })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
    opanModal() {
      this.saveForm = {
        cateRoot: undefined,
        cateName: '',
        projectType: undefined,
      }
      this.showModal = true
    },
    submit() {
      const { projectType, cateRoot, cateName } = this.saveForm
      this.$message.destroy()
      if (!projectType) {
        this.$message.warn('请选择项目类型')
        this.$refs.projectType.focus()
        return
      }
      if (!cateRoot) {
        this.$message.warn('请选择一级科目')
        this.$refs.cateRoot.focus()
        return
      }
      if (cateName.trim() == '') {
        this.$message.warn('请输入二级科目名称')
        this.$refs.cateName.focus()
        return
      }
      let params = {
        projectType,
        cateRoot,
        cateName: cateName.trim(),
      }
      this.submiting = true
      saveRecord(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.showModal = false
            this.load()
          } else {
            this.$message.warn(data.msg)
          }
          this.submiting = false
        })
        .catch(() => {
          this.submiting = false
          this.$message.warn('服务器响应错误')
        })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
